import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { take } from 'rxjs/operators';
import { DadosEmpresaService } from 'src/app/services/dados-empresa.service';
import { HeaderComponent } from '../../components/header/header.component';
import { BotaoChatComponent } from '../../components/botao-chat/botao-chat.component';
import { LoadingGenericoComponent } from '../../components/loading-generico/loading-generico.component';
import { SuccessGenericoComponent } from '../../components/success-generico/success-generico.component';
import { ErrorGenericoComponent } from '../../components/error-generico/error-generico.component';
import { ConfirmaExclusaoComponent } from '../dados-empresa/confirma-exclusao/confirma-exclusao.component';
import { BreadcrumbComponent } from '../../components/breadcrumb/breadcrumb.component';
import { FooterComponent } from '../../components/footer/footer.component';
import { CamelCasePipe } from '../../pipes/camel-case.pipe';

@Component({
    selector: 'app-enderecos-inativos',
    templateUrl: './enderecos-inativos.component.html',
    styleUrls: ['./enderecos-inativos.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [HeaderComponent, BotaoChatComponent, LoadingGenericoComponent, SuccessGenericoComponent, ErrorGenericoComponent, ConfirmaExclusaoComponent, BreadcrumbComponent, FooterComponent, CamelCasePipe]
})
export class EnderecosInativosComponent implements OnInit {

  idEmpresa: number = localStorage.idEmpresaLogada;
  enderecosInativos: any = null;
  idEnderecoParaAtivar: number;

  // ALERTS FINAIS
  alertLoading: boolean = false;
  alertSucesso: boolean = false;
  alertError: boolean = false;
  alertConfirmacao: boolean = false;

  constructor(private readonly service: DadosEmpresaService, public rota: Router) { }

  ngOnInit(): void {
    this.getAllEnderecosInativos();
  }

  getAllEnderecosInativos() {
    this.service.getEnderecosInativos(this.idEmpresa).pipe(take(1)).subscribe({
      next: (response: any) => {
        if (response.status === 'OK') {
          this.enderecosInativos = response.response;
        } else {
          this.enderecosInativos = undefined;
        }
      },
      error: (erro: any) => {
        console.error(erro);
        this.enderecosInativos = false;
      }
    });
  }

  ativarEndereco() {
    this.alertLoading = true;

    this.service.activateEndereco(this.idEmpresa, this.idEnderecoParaAtivar).pipe(take(1)).subscribe({
      next: (response: any) => {
        this.alertLoading = false;
        if (response.status === 'OK') {
          this.alertSucesso = true;
          this.getAllEnderecosInativos();
        } else {
          this.alertError = true;
        }
      },
      error: (erro: any) => {
        console.error(erro);
        this.alertError = true;
      }
    });
  }

  // CONFIRMACAO
  abrirAlertConfirmacao(idEndereco: number) {
    this.alertConfirmacao = true;
    this.idEnderecoParaAtivar = idEndereco;
  }

  fecharAlertConfirmacao(evento: string) {
    // Se clicar no botão de CONFIRMAR ele chama a função pra excluir
    if(evento === 'Confirmar') {
      this.alertConfirmacao = false;
      this.ativarEndereco();
    } else { // Se não apenas fecha o alert de confirmação e não faz nada
      this.alertConfirmacao = false;
    }

  }

   // Fechar o alerta de sucesso, clicando no botão OK
   fecharAlertSucesso(evento: string) { this.alertSucesso = false; }

  // Fechar o alerta de erro, clicando no botão OK
  fecharAlertError(evento: string) { this.alertError = false; }

  voltarAbaEnderecos() {
    this.rota.navigate(['dados-empresa']);

    // CLICAR NA ABA DE ENDEREÇO, AI TENTA ALGUMAS VEZES
    setTimeout(function() {
      if(document.getElementById('enderecoTab')) {
        (<HTMLLinkElement>document.getElementById('enderecoTab')).click();
      } else {
        setTimeout(function() {
          if(document.getElementById('enderecoTab')) {
            (<HTMLLinkElement>document.getElementById('enderecoTab')).click();
          } else {
            setTimeout(function() {
              if(document.getElementById('enderecoTab')) {
                (<HTMLLinkElement>document.getElementById('enderecoTab')).click();
              }
            }, 1500);
          }
        },1500);
      }
    }, 1500);
  }

}
